import {getLocationById, searchLocation} from "@/http/services/http-services-route";
import autocomplete from "autocompleter";
import {WKT} from "ol/format";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {Icon, Style} from "ol/style";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {removeLayer, setLayerClick} from "@/helpers/ol-layer-helper";
import {displayFeatureInfo} from "@/modules/ol-service-wms";
import {generateCanvas} from "@/helpers/canvas-helper";
import {loadMapClick} from "@/helpers/ol-event-helper";
import {loadGeomDependentList} from "@/helpers/ol-geo-dependent-helper";
// import {goToLocationByAddressID} from "@/helpers/ol/ol-route-helper";

export function initLocationSearch(input) {

    input.value = ''

    autocomplete({
        input: input,
        fetch: function(text, update) {
            text = text.toLowerCase();

            const suggestions = []
            searchLocation(text).then(locations => {
                locations.suggestions.map(location => {
                    const suggestion = {}
                    suggestion.label = location.value
                    suggestion.value = location.data.id
                    suggestions.push(suggestion)
                })
                update(suggestions);
            })
        },
        onSelect: function(item) {
            input.value = item.label;

            window.locationByAdressValue = item.value

            const format = new WKT();

            getLocationById(item.value).then((data) => {

                const location = data.response.docs[0]

                const feature = format.readFeature(location.centroide_ll, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857',
                });

                const coordinates = feature.getGeometry().flatCoordinates
                addNewNotificationLayerClick(feature.getGeometry().flatCoordinates, window.map)

                setLayerClick(coordinates)
                loadGeomDependentList(coordinates)

                window.map.getView().animate({
                    center: feature.getGeometry().flatCoordinates,
                    duration: 2000,
                    zoom: 19
                });
            })
        }
    });
}

export function addNewNotificationLayerClick(coordinate, map) {

    removeLayer('notificationGeometry')

    const iconFeature = new Feature({
        geometry: new Point(coordinate),
    });

    const iconStyle = new Style({
        image: new Icon({
            anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: 'public/img/marker.png',
        }),
    });

    iconFeature.setStyle(iconStyle);

    const layer = new VectorLayer({
        name: 'notificationGeometry',
        source: new VectorSource({
            features: [iconFeature],
        })
    })

    map.addLayer(layer);
}
